import ModelsIcon from '@/Theme/icons/modelsIcon';
import { icons as modelIcons } from '@/Theme/icons/modelsIcons/index';
import { get } from 'lodash';
import { useCallback } from 'react';

const useGetModelsIcons = () => {
  const getIcon = useCallback((icon) => {
    const Icon = get(modelIcons, icon);
    return Icon ? (
      <Icon className="h-6 w-6" />
    ) : (
      <ModelsIcon className="h-6 w-6 stroke-raisin-black dark:stroke-crystal-bell" />
    );
  }, []);

  return { getIcon };
};

export default useGetModelsIcons;
